export const PRIVACY_POLICY_URL = 'https://placer.ai/privacy-policy';
export const TERMS_OF_SERVICE_URL = 'https://placer.ai/terms-of-service';

export const SIGNUP_ROUTE = '/auth/signup';
export const SIGNUP_FULL_FORM_STEP_ROUTE = SIGNUP_ROUTE + '/access';
export const SIGNUP_CONFIRM_EMAIL_STEP_ROUTE = SIGNUP_ROUTE + '/confirm';
